import { createFileRoute } from '@tanstack/react-router';

import { QueryCreationPage } from '@/entities/query-builder/QueryCreationPage';

export const Route = createFileRoute('/workspace/$workspaceId/create-new')({
  component: QueryCreationPage,
});
